app.service('instalmentSlider', () => {

	return class {
		constructor(props) {
			this.props = props;

			this.$el = $(props.element);
			this.$thumb = this.$el.find('.instalment-thumb');
			this.$pricing = this.$el
				.closest('.instalment-item')
				.find('.js-instalment-pricing');
			this.$promotionsPackage = this.$el
				.closest('.instalment-item')
				.find('.promotions-package-item');

			this.size = this.$el.data('size');
			this.code = this.$el.data('code');
			this.warranty = this.$el.data('warranty');
			this.selectedCode = props.selectedCode ? props.selectedCode : '';
			this.duration = props.duration;
			this.rangeMin = Math.max(this.$pricing.first().data('option') / 1, 1);
			this.rangeMax = Math.max(this.$pricing.last().data('option') / 1, 1);
			this.rangeStep = this.size > 1 ? Math.max((this.rangeMax - this.rangeMin) / (this.size-1), 1) : 1;
			if(this.selectedCode && this.selectedCode !== this.code) {
				this.duration = this.$el.data('duration');
			}

			this.state = {
				isDragging: false,
				duration: this.duration
			};
			this.attachEvents();
			this.render();
			this.props.onInit && this.props.onInit.call(this, this.duration);
		}

		getDuration(e) {
			const leftOffset = e.clientX - this.$el.offset().left;
			const width = this.$el.width();

			return (
				((Math.max(
					Math.min(Math.ceil((leftOffset / width) * this.size), this.size),
					1
				) -
				1 ) * this.rangeStep) +
				this.rangeMin
			);
		}

		getPrice(duration) {
			return this.$pricing
				.filter(`[data-option=${duration}]`)
				.find('.instalment-price')
				.text()
				.trim();
		}

		runCallback() {
			const duration = this.state.duration;
			const price = this.getPrice(duration);

			this.props.onChange({
				code: this.code,
				duration,
				price,
				warranty: this.warranty
			});
		}

		handleMove(e) {
			if (this.state.isDragging) {
				const duration = this.getDuration(e);
				const price = this.getPrice(duration);

				this.state.duration = duration;

				this.$thumb.addClass('is-active');

				this.props.onChange({
					code: this.code,
					duration,
					price,
					warranty: this.warranty
				});

				this.render();
			}
		}

		attachEvents() {
			this.$el
				.on('mousedown', () => {
					this.state.isDragging = true;
				})
				.on('touchstart', e => {
					this.state.isDragging = true;
				})
				.on('mouseup touchend mouseleave touchleave', () => {
					this.state.isDragging = false;

					this.$thumb.removeClass('is-active');
				})
				.on('mousemove', e => {
					this.handleMove(e);
				})
				.on('touchmove', e => {
					this.handleMove(e.originalEvent.touches[0]);
				})
				.on('dragstart', e => {
					e.preventDefault();
				});
		}

		render() {
			var { duration } = this.state;
			duration = Math.min(this.rangeMax, duration);
			duration = Math.max(this.rangeMin, duration);
			
			const position = (duration - this.rangeMin)/this.rangeStep;
			const $unit = this.$el.find('.js-range-unit').eq(position);

			this.$thumb.text(duration).appendTo($unit);

			$unit.addClass('active');
			$unit.prevAll().addClass('active');
			$unit.nextAll().removeClass('active');

			this.$pricing
				.eq(position)
				.addClass('selected-pricing')
				.siblings()
				.removeClass('selected-pricing');
			
			this.$promotionsPackage.eq(position)
				.addClass('promotions-package-item-visible')
				.siblings()
				.removeClass('promotions-package-item-visible');
		}
	};
});
